var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShyLogoHorizontalGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "30 196 446 102",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Warstwa 1",
    id: "Warstwa_1",
    style: {
      maxHeight: 500
    },
    width: 446,
    height: 102,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d4bc87;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.62,237.93c-2.57,0-4.37,7.72-4.37,7.72v22.33l-32.88,14.44,37.1-65.09,37.69,65.33-33.2-14.65v-22.33s-1.8-7.72-4.37-7.72",
    className: "cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "206.71 233.61 192.5 266.31 195.73 266.31 208.48 236.69 209.37 236.69 217.14 254.73 203.64 254.73 202.43 257.53 218.34 257.53 222.12 266.31 225.35 266.31 211.14 233.61 206.71 233.61",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.83 263.23 243.71 263.23 231.65 233.61 228.38 233.61 241.89 266.31 246.65 266.31 260.11 233.61 256.93 233.61 244.83 263.23",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 32.7,
    width: 2.94,
    y: 233.61,
    x: 269.31,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.14 233.61 280.94 266.31 284.16 266.31 296.92 236.69 297.81 236.69 305.57 254.73 292.07 254.73 290.87 257.53 306.78 257.53 310.56 266.31 313.78 266.31 299.58 233.61 295.14 233.61",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.35 236.41 329.11 236.41 329.11 266.31 332.05 266.31 332.05 236.41 344.85 236.41 344.85 233.61 316.35 233.61 316.35 236.41",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 32.7,
    width: 2.94,
    y: 233.61,
    x: 354.76,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.68,235.25c-2.63-1.4-5.54-2.1-8.71-2.1s-6,.7-8.64,2.1c-2.65,1.4-4.74,3.39-6.28,5.96-1.54,2.57-2.31,5.49-2.31,8.76s.77,6.19,2.31,8.76c1.54,2.57,3.64,4.55,6.28,5.96,2.65,1.4,5.53,2.1,8.64,2.1s6.08-.7,8.71-2.1c2.63-1.4,4.73-3.39,6.28-5.96,1.56-2.57,2.34-5.49,2.34-8.76s-.78-6.19-2.34-8.76c-1.56-2.57-3.65-4.55-6.28-5.96Zm3.69,22.03c-1.29,2.13-3.02,3.78-5.19,4.95-2.16,1.17-4.57,1.75-7.22,1.75s-5.01-.58-7.19-1.75c-2.18-1.17-3.91-2.82-5.19-4.95-1.28-2.13-1.92-4.57-1.92-7.31s.64-5.18,1.92-7.31c1.28-2.13,3.01-3.78,5.19-4.95,2.18-1.17,4.58-1.75,7.19-1.75s5.05,.58,7.22,1.75c2.16,1.17,3.89,2.82,5.19,4.95,1.29,2.13,1.94,4.57,1.94,7.31s-.65,5.18-1.94,7.31Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.69 233.61 439.69 263 438.61 263 419.51 233.61 414.37 233.61 414.37 266.31 417.31 266.31 417.31 236.93 418.39 236.93 437.49 266.31 442.63 266.31 442.63 233.61 439.69 233.61",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.78,253.62c-1.34,0-2.45-.27-3.35-.82-.89-.55-1.56-1.27-2.01-2.18-.44-.9-.66-1.91-.66-3.02h2.12c0,.75,.14,1.43,.41,2.04s.7,1.09,1.29,1.45c.58,.37,1.32,.55,2.2,.55,1.21,0,2.12-.31,2.74-.93,.62-.62,.93-1.37,.93-2.23s-.22-1.6-.65-2.2-1.11-1.08-2.03-1.44l-2.74-1.04c-.9-.36-1.64-.77-2.22-1.24s-1-1.05-1.29-1.72c-.28-.68-.42-1.49-.42-2.43,0-.89,.23-1.71,.69-2.47,.46-.76,1.12-1.38,1.96-1.84,.85-.46,1.83-.69,2.94-.69,1.19,0,2.22,.26,3.09,.79s1.54,1.25,1.99,2.16c.45,.91,.68,1.94,.68,3.07h-2.12c0-.73-.14-1.41-.42-2.02-.28-.61-.7-1.1-1.24-1.47-.55-.37-1.21-.55-1.98-.55-1.05,0-1.9,.3-2.53,.9s-.95,1.31-.95,2.12c0,.89,.2,1.6,.61,2.15,.41,.55,1.05,.99,1.94,1.33l2.37,.9c1.04,.4,1.88,.85,2.53,1.36,.65,.51,1.13,1.12,1.44,1.82s.47,1.55,.47,2.53-.23,1.8-.68,2.59-1.11,1.4-1.98,1.86c-.87,.46-1.91,.69-3.14,.69Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.53,253.39v-19.78h2.12v8.82h8.2v-8.82h2.12v19.78h-2.12v-8.99h-8.2v8.99h-2.12Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.35,253.39v-7.21l-5.85-12.58h2.32l4.38,9.61h.42l4.38-9.61h2.32l-5.85,12.58v7.21h-2.12Z",
    className: "cls-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShyLogoHorizontalGold);
export default __webpack_public_path__ + "static/media/shy-logo-horizontal-gold.3c3c270211c3ae00b2e9272398834465.svg";
export { ForwardRef as ReactComponent };